var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38 38",
    style: {
      enableBackground: "new 0 0 38 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3,36H21.8c-0.9,0-1.7-0.8-1.7-1.7V21.8c0-0.9,0.8-1.7,1.7-1.7h12.5c0.9,0,1.7,0.8,1.7,1.7v12.5C36,35.2,35.2,36,34.3,36 z M21.8,21.6c-0.1,0-0.2,0.1-0.2,0.2v12.5c0,0.1,0.1,0.2,0.2,0.2h12.5c0.1,0,0.2-0.1,0.2-0.2V21.8c0-0.1-0.1-0.2-0.2-0.2H21.8z  M16.2,36H3.7C2.8,36,2,35.2,2,34.3V21.8c0-0.9,0.8-1.7,1.7-1.7h12.5c0.9,0,1.7,0.8,1.7,1.7v12.5C17.9,35.2,17.1,36,16.2,36z  M3.7,21.6c-0.1,0-0.2,0.1-0.2,0.2v12.5c0,0.1,0.1,0.2,0.2,0.2h12.5c0.1,0,0.2-0.1,0.2-0.2V21.8c0-0.1-0.1-0.2-0.2-0.2H3.7z  M34.3,17.9H21.8c-0.9,0-1.7-0.8-1.7-1.7V3.7c0-0.9,0.8-1.7,1.7-1.7h12.5C35.2,2,36,2.8,36,3.7v12.5C36,17.1,35.2,17.9,34.3,17.9z  M21.8,3.5c-0.1,0-0.2,0.1-0.2,0.2v12.5c0,0.1,0.1,0.2,0.2,0.2h12.5c0.1,0,0.2-0.1,0.2-0.2V3.7c0-0.1-0.1-0.2-0.2-0.2H21.8z  M16.2,17.9H3.7c-0.9,0-1.7-0.8-1.7-1.7V3.7C2,2.8,2.8,2,3.7,2h12.5c0.9,0,1.7,0.8,1.7,1.7v12.5C17.9,17.1,17.1,17.9,16.2,17.9z  M3.7,3.5c-0.1,0-0.2,0.1-0.2,0.2v12.5c0,0.1,0.1,0.2,0.2,0.2h12.5c0.1,0,0.2-0.1,0.2-0.2V3.7c0-0.1-0.1-0.2-0.2-0.2H3.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDashboard);
export default __webpack_public_path__ + "static/media/picto-dashboard.f83cd015.svg";
export { ForwardRef as ReactComponent };